import React from 'react';
import mixpanel from 'mixpanel-browser';
import configuration from './../../configuration/server';
import * as Sentry from '@sentry/browser';

const versionApiPath = configuration[configuration.STAGE].apiGateway.URL + '/version';
const TENMINUTES = 10 * 60 * 1000;

class VersionPoller extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // 10 minutes
            frequency: configuration[configuration.STAGE].intervalMsec || TENMINUTES,
            // create environment variable REACT_APP_FE_LOCAL_VERSION or just hard-code here.
            feVersion: process.env.REACT_APP_FE_LOCAL_VERSION || configuration[configuration.STAGE].feVersion
        };
    }

    // compare v0.1.63a to e0.1.63b, returning +1 if a>b, 0 if they are equal, -1 if a<b
    // rules:
    // - ignore leading alpha characters
    // - compare one field at a time (between periods)
    // - each field compares as integer
    // - trailing alpha character is a tie breaker
    //
    // example: 0.12.5 > 0.2.3 because integer 12 > integer 2
    // example: 0.12.5b > 0.12.5a because b > a
    versionCompare(a, b) {
        if (!a && !b) return 0;
        if (a && !b) return 1; // something is greater than nothing
        if (!a && b) return -1; // nothing is less than something

        const fields = s =>
            s
                .toLowerCase()
                .replace(/^[a-z]/g, '')
                .split('.');

        const aFields = fields(a);
        const bFields = fields(b);

        for (const i in aFields) {
            const aVal = aFields[i];
            const bVal = bFields[i];
            if (parseInt(aVal, 10) > parseInt(bVal, 10)) return 1;
            if (parseInt(aVal, 10) < parseInt(bVal, 10)) return -1;
            if (aVal > bVal) return 1;
            if (aVal < bVal) return -1;
        }
        return 0;
    }

    checkVersion = () => {
        const { feVersion } = this.state;
        if (!feVersion) {
            Sentry.captureException(new Error(`FE version variable does not exist on stage ${configuration.STAGE}`));
            return;
        }

        fetch(versionApiPath, { method: 'GET' }).then(async data => {
            const { uiMinVersion } = await data.json();
            if (uiMinVersion && feVersion && this.versionCompare(uiMinVersion, feVersion) === 1) {
                mixpanel.track('VersionPoller forced refresh', { _data: { feVersion, uiMinVersion } });
                window.location.reload();
            }
        });
    };

    componentDidMount() {
        const { frequency } = this.state;
        this.poller = setInterval(this.checkVersion, frequency);
    }

    componentWillUnmount() {
        clearInterval(this.poller);
    }

    render() {
        return null;
    }
}

export default VersionPoller;



// WEBPACK FOOTER //
// ./src/components/versionPoller/index.jsx